import { render, staticRenderFns } from "./PublicHolidayRegionEdit.vue?vue&type=template&id=575ebbfa&scoped=true"
import script from "./PublicHolidayRegionEdit.vue?vue&type=script&lang=js"
export * from "./PublicHolidayRegionEdit.vue?vue&type=script&lang=js"
import style0 from "./PublicHolidayRegionEdit.vue?vue&type=style&index=0&id=575ebbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575ebbfa",
  null
  
)

export default component.exports